import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Tabs,
  Nav,
  Tab,
  Table,
  Modal,
  Image,
  Container,
} from "react-bootstrap";

import { appConfig } from "../../config";
var dateFormat = require("dateformat");
class ProductReturnsView extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const data =
      this.props.ProductReturnsDtls && this.props.ProductReturnsDtls.item
        ? this.props.ProductReturnsDtls && this.props.ProductReturnsDtls.item
        : null;

    const items = this.props.ProductReturnls
      ? this.props.ProductReturnls
      : null;
    // console.log("****itemitemitem***************", items);

    const hasMRP = items?.some(
      (item) => item.mrp !== undefined && item.mrp !== null,
    );

    const totalClaimAmount = Array.isArray(items)
      ? items.reduce((sum, item) => sum + Number(item.claimAmount ?? 0), 0)
      : 0;

    const totalApprovedAmount = Array.isArray(items)
      ? items.reduce((sum, item) => {
          if (item.orderStatus === "approved") {
            return sum + Number(item.approvedAmount ?? 0);
          }
          return sum;
        }, 0)
      : 0;

    const hasPurchaseNotes =
      data?.prcpNotes && data.prcpNotes.trim().length > 0;

    const count =
      this.props.ProductReturnDtlsCount && this.props.ProductReturnDtlsCount;
    return (
      <div>
        <Modal
          show={this.props.show}
          onHide={this.props.handleClose}
          backdrop="static"
          size="lg"
          centered
          contentClassName="purchase-return-content"
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>
              <span style={{ fontSize: "20px" }}>Product Return Details</span>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ fontSize: "15px" }}>
            <Row>
              <Col xs={12} sm={12} md={8} lg={8}>
                <h6>
                  Order No:{" "}
                  {data !== null && data.orderNo ? data.orderNo : null}|
                  <span className="cmn_Cap">
                    {data !== null && data.orderTrk ? data.orderTrk : null}{" "}
                    Order
                  </span>{" "}
                </h6>
              </Col>
              <Col xs={12} sm={12} md={4} lg={4}>
                <h6>
                  Status:{" "}
                  <span className="cmn_Cap">
                    {data !== null && data.status ? data.status : null}
                  </span>
                </h6>
              </Col>
            </Row>
            <hr />

            <Row>
              <Col xs={12} sm={12} md={4} lg={4}>
                <div>
                  <p className="boldClass">Order From:</p>
                  <p>
                    <span className="cmn_Cap">
                      {data !== null && data.orderFrom
                        ? data.orderFrom.name + " " + data.orderFrom.lName
                        : "---"}
                    </span>
                    <br />
                    <span className="cmn_Cap">
                      {data !== null && data.orderFromName
                        ? data.orderFromName
                        : "---"}
                    </span>
                    <br />
                    {data !== null && data.orderFrom !== null && data.orderFrom
                      ? data.orderFrom.mobileNo
                      : "---"}
                    <br />
                    {data !== null && data.chmstDtls && data.chmstDtls.email
                      ? data.chmstDtls.email
                      : "---"}
                    <br />
                    {data !== null && data.chmstDtls && data.chmstDtls.website
                      ? data.chmstDtls.website
                      : "---"}
                    <br />
                    <span className="cmn_Cap">
                      {data !== null && data.addr},
                      {data !== null && data.pincode}
                    </span>
                  </p>
                </div>
              </Col>

              <Col xs={12} sm={12} md={4} lg={4}></Col>

              <Col xs={12} sm={12} md={4} lg={4}>
                <div>
                  <p className="boldClass">Order To:</p>
                  <p>
                    <span className="cmn_Cap">
                      {data !== null && data.orderTo
                        ? data.orderTo.name + " " + data.orderTo.lName
                        : "---"}
                    </span>
                    <br />
                    <span className="cmn_Cap">
                      {data !== null && data.orderToName
                        ? data.orderToName
                        : "---"}
                    </span>
                    <br />
                    {data !== null && data.orderTo !== null && data.orderTo
                      ? data.orderTo.mobileNo
                      : "---"}
                    <br />
                    {data !== null && data.orderTo !== null && data.orderTo
                      ? data.orderTo.email
                      : "---"}
                    <br />
                    <span>
                      {data !== null && data.city ? data.city : "---"}
                    </span>
                    <br />
                    <span>
                      {data !== null &&
                        data.createdAt !== null &&
                        dateFormat(data.createdAt, "dd-mmm-yyyy, h:MM TT")}
                    </span>
                    <br />
                  </p>
                </div>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col xs={12} sm={12} md={3} lg={3}>
                <h4>Item Details</h4>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}></Col>
              <Col xs={12} sm={12} md={3} lg={3}></Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div>
                  <span className="cmnPageCount">
                    {" "}
                    {count !== undefined ? count : 0}
                  </span>
                  <span className="cmnResutText">Items</span>
                </div>
              </Col>
            </Row>

            <Table responsive bordered className="cmnMainTable">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Item Code</th>
                  <th>Item Name</th>
                  <th>Quantity</th>

                  {this.props.ProductReturnls?.some(
                    (item) => item?.status === "accepted",
                  ) && <th>Approved Qnt</th>}

                  <th>Unit</th>
                  <th>Unit Price</th>
                  {hasMRP && <th>MRP</th>}
                  <th>Availability</th>
                  <th>Batch No</th>
                  <th>Purchase Invoice No</th>
                  <th>Purchase Date</th>
                  <th>Expiry Date</th>
                  <th>Claim Amount</th>

                  {this.props.ProductReturnls?.some(
                    (item) => item?.status === "accepted",
                  ) && <th>Approved Amount</th>}
                </tr>
              </thead>

              <tbody>
                {this.props.ProductReturnls &&
                  this.props.ProductReturnls.map((item, i) => (
                    <tr key={i}>
                      <td className="cmn_Cap">{i + 1}</td>
                      <td>
                        {item !== null &&
                        item.itemCode &&
                        item.itemCode.drugCode
                          ? item.itemCode.drugCode
                          : null}
                      </td>
                      <td className="cmn_Cap">
                        {item !== null &&
                        item.itemCode &&
                        item.itemCode.drugName
                          ? item.itemCode.drugName
                          : null}
                      </td>
                      <td>{item !== null && item.qntty}</td>
                      {item?.status === "accepted" && (
                        <td>{item?.approvedQntty}</td>
                      )}
                      <td>
                        {item !== null &&
                          item.unitType !== null &&
                          item.unitType !== undefined &&
                          item.unitType.name}
                      </td>
                      <td>{item !== null && item.price}</td>
                      {hasMRP && <td>{item?.mrp ?? "-"}</td>}
                      <td>
                        {item !== null && item.avlble == true ? "Yes" : "No"}
                      </td>
                      <td>{item !== null && item.batchNo}</td>
                      <td className="cmn_Cap">
                        {item !== null && item.purchaseInvoiceNo}
                      </td>
                      <td className="cmn_Cap">
                        {item?.purchaseDate
                          ? dateFormat(item.purchaseDate, "dd-mmm-yyyy")
                          : ""}
                      </td>

                      <td className="cmn_Cap">
                        {item?.expiryDate
                          ? dateFormat(item.expiryDate, "dd-mmm-yyyy")
                          : ""}
                      </td>
                      <td className="cmn_Cap">{item?.claimAmount}</td>
                      {item?.status === "accepted" && (
  <td className="cmn_Cap">{item?.approvedAmount}</td>
)}
                    </tr>
                  ))}
              </tbody>
            </Table>
            {/* TOTAL CLAIM AMOUNT */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "12px 10px",
                fontWeight: "bold",
                fontSize: "15px",
                borderTop: "1px solid #ddd",
                marginTop: "10px",
              }}
            >
              <span style={{ marginRight: "10px" }}>Total Claim Amount :</span>
              <span style={{ color: "#1768B7" }}>
                ₹ {totalClaimAmount.toFixed(2)}
              </span>
            </div>

            {/* TOTAL APPROVED AMOUNT */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "12px 10px",
                fontWeight: "bold",
                fontSize: "15px",
              }}
            >
              <span style={{ marginRight: "10px" }}>
                Total Approved Amount :
              </span>
              <span style={{ color: "#1768B7" }}>
                ₹ {totalApprovedAmount.toFixed(2)}
              </span>
            </div>

            {hasPurchaseNotes && (
              <div
                style={{
                  marginTop: "14px",
                  padding: "14px 16px",
                  backgroundColor: "#F5F9FF",
                  borderLeft: "4px solid #1768B7",
                  borderRadius: "6px",
                  fontSize: "14px",
                  color: "#333",
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    marginBottom: "6px",
                    color: "#1768B7",
                  }}
                >
                  📝 Purchase Notes
                </div>

                <div style={{ lineHeight: "1.6" }}>{data.prcpNotes}</div>
              </div>
            )}

            {(this.props.ProductReturnls === undefined ||
              (this.props.ProductReturnls &&
                this.props.ProductReturnls.length === 0)) && (
              <div>
                <div className="noDataImgDiv">
                  <Image
                    className="noDataImg"
                    src={require("../../assets/img/nodata4.png")}
                  />
                </div>
                <div className="noDataTextDiv">No Data Found</div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}></Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default ProductReturnsView;
